export const environment = {
    seedFunctionApiUrl: 'https://func-seh-dev-uks-002-feg6eaexcbddd0f7.uksouth-01.azurewebsites.net/api/{0}?code=BAlARtVG54uzWg25dQtFsQtmQlfC6H3JjDOff55dfNvyAzFu9i7iKw==',
    sehApiUrl : 'https://app-seh-dev-uks-001.azurewebsites.net/api/',
    msalConfig: {
        auth: {
            clientId: 'f273590a-2504-4451-832a-f043b77add8d',
            authority: 'https://login.microsoftonline.com/01583be4-f096-49f4-bd19-56b649a8482f',
            redirectUri: 'https://dev.admin.seh.icshosting.net/auth',
        },
    },
    apiConfig: {
        scopes: ['api://7171a077-6907-4a14-bf33-2469a0dd218f/access_as_user'],
        uri: 'https://app-seh-dev-uks-001.azurewebsites.net/',
    }
};
